import { createContext, useContext, useState, useCallback } from "react";

type ReviewGridViewContextType = {
    isGridView: boolean;
    setIsGridView: (value: boolean | ((prev: boolean) => boolean)) => void;
};

const ReviewGridViewContext = createContext<ReviewGridViewContextType | undefined>(undefined);

export function useReviewGridView() {
    const ctx = useContext(ReviewGridViewContext);
    if (!ctx) throw new Error("useReviewGridView must be used within ReviewGridViewProvider");
    return ctx;
}

export function ReviewGridViewProvider({ children }: { children: React.ReactNode }) {
    const [isGridView, setState] = useState(false);
    const setIsGridView = useCallback((value: boolean | ((prev: boolean) => boolean)) => {
        setState((prev) => (typeof value === "function" ? value(prev) : value));
    }, []);
    return (
        <ReviewGridViewContext.Provider value={{ isGridView, setIsGridView }}>
            {children}
        </ReviewGridViewContext.Provider>
    );
}
